import { render, staticRenderFns } from "./ButtonWatchTrailer.vue?vue&type=template&id=65540652&scoped=true&lang=pug&"
import script from "./ButtonWatchTrailer.vue?vue&type=script&lang=js&"
export * from "./ButtonWatchTrailer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWatchTrailer.vue?vue&type=style&index=0&id=65540652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65540652",
  null
  
)

export default component.exports